import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { auth } from '../firebase';
import {Navbar, Icon} from 'react-materialize'

const PasswordForgetPage = () =>
  <div>
    <h1>PasswordForget</h1>
    <PasswordForgetForm />
  </div>

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value,
});

const INITIAL_STATE = {
  email: '',
  error: null,
};

class PasswordForgetForm extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

  onSubmit = (event) => {
    const { email } = this.state;

    auth.doPasswordReset(email)
      .then(() => {
        this.setState(() => ({ ...INITIAL_STATE }));
      })
      .catch(error => {
        this.setState(byPropKey('error', error));
      });

    event.preventDefault();
  }

  render() {
    const {
      email,
      error,
    } = this.state;

    const isInvalid = email === '';

    return (
      <form onSubmit={this.onSubmit}>
        <div className='row'>
          <div className='input-field col s12'>
            <input
              className='validate'
              type='email'
              name='email'
              id='email'
              value={this.state.email}
              onChange={event => this.setState(byPropKey('email', event.target.value))}
            />
            <label htmlFor="passwordOne">Endereço de email</label>
          </div>
        </div>
        <center>
          <div className='row'>
            <button type='submit' disabled={isInvalid} name='btn_login' className='col s12 btn btn-large waves-effect indigo'>Recuperar senha<Icon>keyboard_arrow_right</Icon></button>
            { error && <p>{error.message}</p> }
          </div>
        </center>
      </form>
    );
  }
}

const PasswordForgetLink = () =>
  <p>
    <Link to="/pw-forget">Esqueceu sua senha?</Link>
  </p>

export default PasswordForgetPage;

export {
  PasswordForgetForm,
  PasswordForgetLink,
};



// WEBPACK FOOTER //
// ./src/components/PasswordForget.js